import FormInputTypes from '../components/atoms/formEnums/formInputTypes';
import { IconType } from '../components/atoms/icon/icon';
import tableBillingTransactionsMonthDetail from './tableBillingTransactionsMonthDetail';
export default {
  attributeName: 'billingtransactionsmonthly',
  idAttribute: 'id',
  getURL: 'billingtransactionsummary',
  isDragable: false,
  canOpen: false,
  canEdit: false,
  canCreate: false,
  canRemove: false,
  emptyMessage: "There are no billing transactions to show for this organization.",
  fields: [
    {
      attributeName: 'month',
      label: 'Month',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      canEdit: false,
      canCreate: false,
      width: '12rem',

    },
    {
      attributeName: 'year',
      label: 'Year',
      type: FormInputTypes.TEXT_INPUT.NUMBER,
      canEdit: false,
      canCreate: false,
      width: '12rem',

    },
    {
      attributeName: 'amount',
      label: 'Amount €',
      type: FormInputTypes.TEXT_INPUT.NUMBER,
      canEdit: false,
      canCreate: false,
      width: '12rem',

    },
    {
      attributeName: 'revenue',
      label: 'Revenue €',
      type: FormInputTypes.TEXT_INPUT.NUMBER,
      canEdit: false,
      canCreate: false,
      width: '12rem',

    },
    {
      attributeName: 'ticketsSold',
      label: 'Num. Tickets Sold',
      type: FormInputTypes.TEXT_INPUT.NUMBER,
      canEdit: false,
      canCreate: false,
      width: '12rem',

    },
    {
      attributeName: 'ticketsReturned',
      label: 'Num. Tickets Returned',
      type: FormInputTypes.TEXT_INPUT.NUMBER,
      canEdit: false,
      canCreate: false,
      width: '12rem',

    },
    
    // {
    //   attributeName: 'pdf',
    //   label:'PDF',
    //   type: FormInputTypes.LINK,
    //   icon: IconType.PDFFILE,
    //   width: '4rem',
    //   target:'_self',
    //   to:'target',
    //   iconSize:'lg',
    //   iconColor:'#cc0000',
    //   helpText: 'PDF file generated for this month.',
    // },   
    // {
    //   attributeName: 'xlsx',
    //   label:'Excel',
    //   type: FormInputTypes.LINK,
    //   icon: IconType.EXCELFILE,
    //   width: '4rem',
    //   target:'_self',
    //   to:'target',
    //   iconSize:'lg',
    //   iconColor:'#00cc00',
    //   helpText: 'EXCEL file generated for this month.',
    // },   

    {
      attributeName: 'csv',
      label:'CSV',
      type: FormInputTypes.LINK,
      icon: IconType.CSVFILE,
      width: '4rem',
      target:'_self',
      iconSize:'lg',
      iconColor:'#0000cc',
      helpText: 'CSV file generated for this month.',
    },   
    {
      attributeName: 'detailView',
      label:'View',
      type: FormInputTypes.LINK,
      icon: IconType.VIEW,
      width: '4rem',
      target:'_self',
      iconSize:'lg',
      iconColor:'#17a2b8',
      helpText: 'Monthly details.',      
    },   
    
    
  ],
};
